



import React, { createContext, useState, useContext } from "react";

const EnergiaHvacDiretaContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaHvacExpansaoDireta_id, setEnergiaHvacExpansaoDireta_id] = useState();

  return (
    <EnergiaHvacDiretaContext.Provider value={{ energiaHvacExpansaoDireta_id, setEnergiaHvacExpansaoDireta_id }} >
      {children}
    </EnergiaHvacDiretaContext.Provider>
  );
}

export function useEnergiaHvacDiretaContext() {
  const context = useContext(EnergiaHvacDiretaContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaHvacExpansaoDireta_id, setEnergiaHvacExpansaoDireta_id } = context;
  return { energiaHvacExpansaoDireta_id, setEnergiaHvacExpansaoDireta_id };
}

